<template>
  <div class="anketa-2cols styles">
    <div v-html="title" class="title"></div>
    <div class="height">
      <VueScrollPicker
          :options="data"
          v-model="modelValue"
          empty="Error"
          placeholder="-"
      />
    </div>
    <primary-button
        @click="saveLastStep(button.link); events();"
        :disabled="disabled"
        :text="button.text"
        :link="button.link"
    />
  </div>

</template>

<script>
import StyleBlock from "@/components/Anketa/StyleBlock";
import {useHeaderStore} from '@/stores/header'
import anketaMixin from "@/mixins/anketaMixin";
import {useAnketaStore} from "@/stores/anketa";
import {ref} from "vue";
import heightData from "@/data/anketa/heightData";
import headerMixin from "@/mixins/headerMixin";
import selectedMixin from "@/mixins/selectedMixin";
import {useSettingsStore} from "@/stores/settings";
import {useApiStore} from "@/stores/api";

export default {
  name: 'HeightQuestionView',
  components: {StyleBlock},
  mixins: [anketaMixin, headerMixin, selectedMixin],
  props: ['header'],
  setup() {
    const {setValue, getStepData, steps, saveLastStep} = useAnketaStore();
    let modelValue = ref(getStepData(steps.step7) ?? null)
    const {setHeaderData} = useHeaderStore();
    const settings = useSettingsStore();
    const api = useApiStore();
    const anketaStore = useAnketaStore();
    return {
      api, setHeaderData, setValue, getStepData, steps, modelValue, settings, saveLastStep, anketaStore
    };
  },
  watch: {
    modelValue(newVal) {
      this.select(newVal)
      this.disabled = newVal == null;
    }
  },
  methods: {
    async events() {
      const isEdit = this.anketaStore.isFinished();
      const fromPage = this.anketaStore.formFromPage ?? null;
      await this.api.onStageEvent('onFormStage', 'question_8', isEdit ? false : null, fromPage);
    }
  },
  mounted() {
    if (this.modelValue == null) {
      this.disabled = true
    }
  },
  data() {
    return {
      stepId: 'height',
      title: "<span>Укажи свой рост:</span>",
      button: {
        text: 'Продолжить',
        link: 'anketa.step8',
      },
      data: heightData,
      step_number: "step7",
    }
  }
}
</script>